import { buildDefaultMiddleware } from 'utilities/state';

export default buildDefaultMiddleware('competencies', 'store:competencies');